export default "__VITE_ASSET__bb131fac__"